// MN Quick Add (global) — AJAX add-to-cart
(function () {
  function closestForm(target) {
    return target.closest('.mn-mncard__form, .mn-mncard__variantForm');
  }

  async function addToCart(form) {
    const fd = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }

  async function refreshCartCount() {
    try {
      const r = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await r.json();
      document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (e) {}
  }

  document.addEventListener('submit', async (e) => {
    const form = closestForm(e.target);
    if (!form) return;

    // ✅ STOP normal submit + STOP other JS listeners (prevents double add)
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    // ✅ LOCK so it can’t fire twice (double click or duplicate listeners)
    if (form.dataset.mnAdding === '1') return;
    form.dataset.mnAdding = '1';

    const btn = form.querySelector('button[type="submit"]');
    const prevText = btn ? btn.textContent : null;

    try {
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'ADDING...';
      }

      await addToCart(form);
      refreshCartCount();

      if (btn) btn.textContent = 'ADDED ✓';
      setTimeout(() => {
        if (btn) {
          btn.disabled = false;
          btn.textContent = prevText || 'QUICK ADD +';
        }
      }, 900);

    } catch (err) {
      console.error(err);
      if (btn) {
        btn.disabled = false;
        btn.textContent = prevText || 'QUICK ADD +';
      }
    } finally {
      // ✅ UNLOCK
      form.dataset.mnAdding = '0';
    }
  }, true);
})();

/* ---------------------------------------------------------------------------
   SUBSCRIPTION BADGE FIX — added 30 Sep 2026

   Symptom: on a supplement PDP, for a variant that has a subscription, the
   SUBSCRIPTION badge sits under the price while "One-time purchase" is still
   ticked — and it disappears when "Subscribe" IS ticked. It only misbehaves
   when the variant is discounted, which is what made it look intermittent.

   Cause: the Shopify Subscriptions app renders its badge as

     class="badge price__badge-sale uppercase color-scheme-5 price__badge--subscription"
     style="display: inline-block !important"

   That price__badge-sale class is the same one the "Save 20%" badge uses, and
   the badge logic in sections/mn-pdp-redesign-styles.liquid keys off it:

     • mnBadgeLooksLikeSubscription() early-returns false for anything carrying
       price__badge-sale, so it never recognises its own subscription badge;
     • the pass that should hide the badge skips it for that same reason;
     • the final `.price__badge-sale` pass then sets
         display: oneTimeOnSale ? 'inline-block' : 'none'
       which forces the badge visible on any discounted variant, whichever
       purchase option is selected — and hides it when Subscribe is chosen.

   Off sale, oneTimeOnSale is false, so that last pass happens to hide it and
   everything looks correct. Hence "only during sales".

   Fix: strip the misleading price__badge-sale class from the subscription
   badge. It contributes no styling of its own here (the pill comes from
   .badge + the colour scheme — verified: zero computed-style difference), so
   removing it is visually inert. With the class gone, the section's existing
   logic classifies the badge correctly and shows/hides it in step with the
   radio, using its own rules. Nothing else is overridden.

   The inline display is also cleared so the stylesheet's "hidden unless
   data-mn-purchase-mode=subscribe" rule governs in the gap before the
   section's next pass — hidden is the safe direction.

   Deliberately guarded: it only acts while the class is still present, so it
   cannot ping-pong with the section's own MutationObserver (which watches
   class and style on the same nodes).

   NOTE: this is a targeted patch in an already-loaded asset. The tidier home
   is the three class checks inside mn-pdp-redesign-styles.liquid itself —
   worth folding in next time that section is edited properly via CLI/git.
   --------------------------------------------------------------------------- */
(function () {
  var SUB_CLASS = 'price__badge--subscription';
  var SALE_CLASS = 'price__badge-sale';
  var queued = false;

  function declash() {
    queued = false;
    var badges = document.querySelectorAll('.' + SUB_CLASS);
    for (var i = 0; i < badges.length; i++) {
      var badge = badges[i];
      // already cleaned — do nothing, so we never mutate in response to our
      // own (or the section's) changes
      if (!badge.classList.contains(SALE_CLASS)) continue;
      badge.classList.remove(SALE_CLASS);
      badge.style.removeProperty('display');
    }
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(declash);
  }

  function start() {
    declash();

    var scope =
      document.querySelector('.product__info-wrapper') ||
      document.querySelector('.product__info-container') ||
      document.body;
    if (!scope) return;

    new MutationObserver(queue).observe(scope, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    // the app re-injects the badge on variant change and after its own
    // async passes; these catch anything the observer misses on first paint
    [100, 400, 1000, 2500, 6000].forEach(function (ms) {
      setTimeout(declash, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ---------------------------------------------------------------------------
   QUICK ADD SHEET LOADER — added 15 Oct 2026
   Loads assets/mn-quicksheet.css + assets/mn-quicksheet.js (mobile quick add
   bottom sheet + in-stock-first variant sorting on product cards) from the
   same asset folder as this file, so layout/theme.liquid doesn't need editing.
   --------------------------------------------------------------------------- */
(function () {
  var me = document.currentScript && document.currentScript.src;
  if (!me || me.indexOf('mn-quickadd.js') < 0) return;
  var base = me.split('?')[0];
  var ver = '?v=20261015d8';
  var css = document.createElement('link');
  css.rel = 'stylesheet';
  css.href = base.replace('mn-quickadd.js', 'mn-quicksheet.css') + ver;
  document.head.appendChild(css);
  var js = document.createElement('script');
  js.src = base.replace('mn-quickadd.js', 'mn-quicksheet.js') + ver;
  js.defer = true;
  document.head.appendChild(js);
})();
